module.exports = __webpack_public_path__ + "static/media/octo_connection.a306c4b3.jpg";